import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';
import script from './HseClickableIcon.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,_vm._g(_vm._b({tag:"component",staticClass:"hse-ClickableIcon",class:{
    'hse-ClickableIcon_disabled': _vm.disabled,
    'hse-ClickableIcon_hovered': _vm.hovered,
    'hse-ClickableIcon_focused': _vm.focused,
    'hse-ClickableIcon_controlledFocus': typeof _vm.focused !== 'undefined'
  }},'component',_vm.componentProps,false),_vm.$listeners),[_c('HseIcon',{staticClass:"hse-ClickableIcon__icon",class:{
      'hse-ClickableIcon__icon_disabled': _vm.disabled,
      'hse-ClickableIcon__icon_hovered': _vm.hovered,
      'hse-ClickableIcon__icon_focused': _vm.focused
    },style:(_vm.iconStyleComputed),attrs:{"size":_vm.size,"icon":_vm.icon}})],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
